import { createReducer, on } from '@ngrx/store';
import {
  loadStrategyList,
  loadStrategyListSuccess,
  loadStrategyListFailure,
  clearStrategyList,
} from './strategy.actions';

export interface StrategyState {
  data: any[] | null;
  loading: boolean;
  error: any;
}

export const initialState: StrategyState = {
  data: null,
  loading: false,
  error: null,
};

export const strategyReducer = createReducer(
  initialState,
  on(loadStrategyList, (state) => ({ ...state, loading: true, error: null })),
  on(loadStrategyListSuccess, (state, { data }) => ({ ...state, loading: false, data })),
  on(loadStrategyListFailure, (state, { error }) => ({ ...state, loading: false, error })),
  on(clearStrategyList, (state) => ({ ...state, data: null }))
);
